var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "return-svgrepo-com 1",
    clipPath: "url(#clip0_208_1913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shopicon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.41663 11.9167V13C5.41663 17.1817 8.81829 20.5834 13 20.5834C17.1816 20.5834 20.5833 17.1817 20.5833 13C20.5833 8.81836 17.1816 5.41669 13 5.41669H9.39138L11.2731 3.08861L9.58854 1.72632L5.72917 6.50003L9.58854 11.2737L11.2731 9.91144L9.39138 7.58336H13C15.9867 7.58336 18.4166 10.0133 18.4166 13C18.4166 15.9868 15.9867 18.4167 13 18.4167C10.0132 18.4167 7.58329 15.9868 7.58329 13V11.9167H5.41663Z",
    fill: "#FFCD00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_1913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnSvgrepoCom1);
export default __webpack_public_path__ + "static/media/return-svgrepo-com 1.10bc7e9c49379c8d666e204b0c31d8b6.svg";
export { ForwardRef as ReactComponent };